// extracted by mini-css-extract-plugin
export default {"name_text":"bot-name_name_text__PEJJw","chatset":"bot-name_chatset__5g2tK","icon_container":"bot-name_icon_container__JIoCA","badge":"bot-name_badge__X3Ho2"};